module.exports = __webpack_public_path__ + "img/codebg.a843564b.png";